import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Table } from 'antd';
import { toJS } from 'mobx';

@inject('apiToolsStore')
@observer
class SearchResult extends Component {
  state={
    addModalVisible: false,
    record: null
  }
  getRowClassName = (record, index) => {
    let className = '';
    className = index % 2 === 0 ? 'oddRow' : 'evenRow';
    return className;
  }
  render() {
    const { apiToolsStore } = this.props
    const { resendList } = apiToolsStore
      return (
        <>
          <Table className='searchResult' dataSource={toJS(resendList)} pagination={false} rowClassName={this.getRowClassName} rowKey="messageId" bordered>
            <Table.Column title='Message ID' dataIndex="messageId" />
            <Table.Column title='Status' dataIndex="resendStatus" />
            <Table.Column title='File Name' dataIndex="fileName" />
          </Table>
        </>
      );
  }
}

export default SearchResult;
